import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { ScheduleService } from "../../services/schedule/schedule.service";
import { takeUntil } from "rxjs/operators";
import { Schedule } from "src/app/models/schedule.model";
import { NgForm } from "@angular/forms";
import Swal from "sweetalert2";
import { PushNotificationService } from "src/app/services/push-notification.service";

@Component({
  selector: "app-schedule",
  templateUrl: "./schedule.component.html",
  styleUrls: ["./schedule.component.css"],
})
export class ScheduleComponent implements OnInit, OnDestroy {
  loading = true;
  private unsubscribe$ = new Subject<void>();
  onecore = [];
  educative = [];
  operative = [];

  isEducative: boolean = false;
  isOperative: boolean = false;
  IsOnecore: boolean = false;
  items: Schedule[] = [];
  LastEvaluatedKey = null;
  item: Schedule = new Schedule("", "", "");
  disabledPush: boolean;
  file: any;
  page = 0;
  minidx = 0;
  itemsPerPage = 15;

  category = [
    { id: 0, name: "Educativa", path: "education" },
    { id: 1, name: "Operativa", path: "operative" },
    { id: 2, name: "Novalogic", path: "novalogic" },
  ];
  data = [
    { id: 0, name: "Educativa" },
    { id: 1, name: "Operativa" },
    { id: 1, name: "Novalogic" },
  ];
  hoursOftheDay = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23,
  ];

  isType = this.data[0];
  private _router: any;
  oneForm: NgForm;
  edForm: NgForm;
  opForm: NgForm;
  day: any;

  constructor(
    private scheduleService: ScheduleService,
    public pushNotification: PushNotificationService
  ) {}

  ngOnInit(): void {
    this.getSchedules();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getSchedules() {
    this.scheduleService
      .getSchedule()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        res.docs.forEach((doc) => {
          console.log(doc.data());
        });
      });
  }

  pushEducation(edForm: NgForm) {
    if (edForm.valid) {
      this.item.title = this.edForm.value.title;
      this.item.subTitle = this.edForm.value.subTitle;
      this.item.link = this.edForm.value.link;
      this.item.hour = this.edForm.value.hour;
      this.item.hourToIndent = this.edForm.value.hourToIndent;
      Swal.fire({
        title: "Agregando el item!",
        html: "Espere unos segundos.",
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      this.scheduleService.createEducationSchedule(this.item);
    } else {
      Swal.fire(
        "El item no ha sido creado!",
        "Error en el formulario.",
        "error"
      );
    }
  }
  pushOperative(opForm: NgForm) {
    if (opForm.valid) {
      this.item.title = this.opForm.value.title;
      this.item.subTitle = this.opForm.value.subTitle;
      this.item.link = this.opForm.value.link;
      this.item.hour = this.opForm.value.hour;
      this.item.hourToIndent = this.opForm.value.hourToIndent;
      Swal.fire({
        title: "Agregando el item!",
        html: "Espere unos segundos.",
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      this.scheduleService.createOperativeSchedule(this.item);
    } else {
      Swal.fire(
        "El item no ha sido creado!",
        "Error en el formulario.",
        "error"
      );
    }
  }
  pushNovalogic(oneForm: NgForm) {
    if (oneForm.valid) {
      this.item.title = this.oneForm.value.title;
      this.item.subTitle = this.oneForm.value.subTitle;
      this.item.link = this.oneForm.value.link;
      this.item.hour = this.oneForm.value.hour;
      this.item.hourToIndent = this.oneForm.value.hourToIndent;
      Swal.fire({
        title: "Agregando el item!",
        html: "Espere unos segundos.",
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      this.scheduleService.createNovalogicSchedule(this.item);
    } else {
      Swal.fire(
        "El item no ha sido creado!",
        "Error en el formulario.",
        "error"
      );
    }
  }

  getDay() {
    switch (new Date().getDay()) {
      case 0:
        this.day = "Sunday";
        break;
      case 1:
        this.day = "Monday";
        break;
      case 2:
        this.day = "Tuesday";
        break;
      case 3:
        this.day = "Wednesday";
        break;
      case 4:
        this.day = "Thursday";
        break;
      case 5:
        this.day = "Friday";
        break;
      case 6:
        this.day = "Saturday";
    }
  }
  getHourPerDay(doc: any) {
    switch (doc.id) {
      case "0":
        this.day.sundayTime = doc.data().schedule.time;
        this.day.sunday = doc.data().schedule.day;

        break;
      case "1":
        this.day.mondayTime = doc.data().schedule.time;
        this.day.monday = doc.data().schedule.day;

        break;
      case "2":
        this.day.tuesdayTime = doc.data().schedule.time;
        this.day.tuesday = doc.data().schedule.day;

        break;
      case "3":
        this.day.wednesdayTime = doc.data().schedule.time;
        this.day.wednesday = doc.data().schedule.day;

        break;
      case "4":
        this.day.thursdayTime = doc.data().schedule.time;
        this.day.thursday = doc.data().schedule.day;

        break;
      case "5":
        this.day.fridayTime = doc.data().schedule.time;
        this.day.friday = doc.data().schedule.day;

        break;
      case "6":
        this.day.saturdayTime = doc.data().schedule.time;
        this.day.saturday = doc.data().schedule.day;

        break;
      default:
        break;
    }
  }
  onSubmit() {
    if (this.edForm.valid) {
      console.log("Form Submitted!");
      this.edForm.reset();
    }
  }
}
